<template>
  <div class="p-carousel-wrap">
    <div class="p-carousel">
      <div class="p-carousel__slide">
        <div
          class="p-carousel__slide__inner"
          v-for="(carouselImage, index) in carouselImages"
          :key="index"
        >
          <img :src="carouselImage" alt="" class="p-carousel__slide__img" />
        </div>
      </div>
      <button class="p-carousel__prev c-btn2 c-btn2--prev is-disabled">
        前へ
      </button>
      <button class="p-carousel__next c-btn2 c-btn2--next is-disabled">
        次へ
      </button>
      <div class="p-carousel__pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

export default {
  name: "Carousel",
  props: {
    carouselImages: Array
  },
  data() {
    return {
      swiper: null
    };
  },
  // mounted() {},
  methods: {
    init() {
      // img要素が生成されるのを待つ
      let slideImg = document.querySelectorAll(".p-carousel__slide__img");
      if (slideImg.length === 0) {
        setTimeout(() => {
          this.init();
        }, 99);
        return;
      }

      // swiper実行
      if (this.swiper) {
        this.swiper.update();
      } else {
        this.swiper = new Swiper(".p-carousel", {
          containerModifierClass: "p-carousel",
          wrapperClass: "p-carousel__slide",
          slideClass: "p-carousel__slide__inner",
          pagination: {
            el: ".p-carousel__pagination",
            type: "bullets",
            clickable: true,
            bulletElement: "li",
            bulletActiveClass: "is-current"
          },
          navigation: {
            nextEl: ".p-carousel__next",
            prevEl: ".p-carousel__prev",
            disabledClass: "is-disabled"
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
